import { takeEvery } from 'redux-saga/effects';
import {
    fetchAsioRolesListForSubscribers,
    fetchAsioRolesForSubscribers,
    fetchSubscribers,
    saveRole,
    fetchConnectedAppsWithResources,
} from '../slice';
import { fetchRolesList } from './fetchRolesListSaga';
import { fetchRoles } from './fetchRolesSaga';
import { getSubscribers } from './subscribersSaga';
import { saveRoleSaga } from './updateRoleSaga';
import { getConnectedApps } from './fetchConnectedAppsSaga';

const subscribersSagas = [
    takeEvery(fetchAsioRolesListForSubscribers.type, fetchRolesList),
    takeEvery(fetchAsioRolesForSubscribers.type, fetchRoles),
    takeEvery(fetchSubscribers.type, getSubscribers),
    takeEvery(saveRole.type, saveRoleSaga),
    takeEvery(fetchConnectedAppsWithResources.type, getConnectedApps),
];

export default subscribersSagas;
